module.exports = __webpack_public_path__ + "media/images/oak/banners/banner-1-bf27b1781e64072fbc56d3409e4d6944.jpg";